import API from '@/utils/Api';
import {get} from '@/context/context';
import router from '@/router';
import AuthRepository from "@/repositories/AuthRepository";
import { UserLoginRequest } from "@/models/User/UserLoginRequest";
import { UserResponse } from "@/models/User/UserResponse";
import { UserRegisterRequest } from "@/models/User/UserRegisterRequest";
import { UserResetPasswordRequest } from "@/models/User/UserResetPasswordRequest";
import { UserSaveResetPasswordRequest } from "@/models/User/UserSaveResetPasswordRequest";
import { UserRegisterResponse } from "@/models/User/UserRegisterResponse";
import {defaultServer, Servers, urls} from "@/serverConfig";

export class AuthService{
    private api: API = get('api');
    private authRepository: AuthRepository = get('authRepository');

    public userAuth: UserResponse|UserRegisterResponse|'' = '';

    private readonly authHeader: string = 'Authorization';
    private readonly authHeaderPrefix: string = '';

    public async register(
        formData: UserRegisterRequest,
    ): Promise<UserRegisterResponse> {
        return await this.authRepository.register({
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            password: formData.password,
            gender: formData.gender,
            birthday: formData.birthday,
            city: formData.city,
            zipCode: formData.zipCode,
            state: formData.state,
            countryId: formData.countryId,
            photoUrl: formData.photoUrl || '',
        });
    }

    public async login(email: string, password: string): Promise<UserResponse> {
        return await this.authRepository.login(new UserLoginRequest({
            email,
            password,
        }));
    }

    public async getTokenByEmail(email: string): Promise<UserResponse> {
        return await this.authRepository.getByEmail(email);
    }

    public async resetPassword(email: string): Promise<void> {
        return await this.authRepository.resetPassword(new UserResetPasswordRequest({
            email
        }));
    }

    public async resetPasswordSave(data: ({token: string, password: string})): Promise<void> {
        return await this.authRepository.resetPasswordSave(new UserSaveResetPasswordRequest({
            token: data.token,
            password: data.password
        }));
    }

    public logout() {
        this.userAuth = '';
        // this.api.serverKeys.map(key => {
        //     // this.api.setCommonHeader(key, '');
        //     localStorage.removeItem(key+'-token');
        // })
        for(let key in Servers) {
            localStorage.removeItem(key+'-token');
        }
        localStorage.removeItem('user-email');
        localStorage.removeItem('user-first');
        localStorage.removeItem('user-last');

        router.push({name: process.env.VUE_APP_LOGOUT_REDIRECT || 'login'});
    }

    public getUserAuth(serverKey?:string): UserResponse|UserRegisterResponse|'' {
        if (this.userAuth) return this.userAuth;

        let token:string|null = '';
        let server:string|undefined = serverKey;
        if (server) {
            token = localStorage.getItem(serverKey+'-token');
        } else {
            Object.keys(urls).map((key: string) => {
                if(localStorage.getItem(key+'-token')){
                    token = localStorage.getItem(key+'-token');
                    server = key;
                }
            })

        }

        if (!token) {
            return this.userAuth;
        }
        if (server) {
            const newUserAuth: UserResponse = {
                id: token,
                firstName: localStorage.getItem('user-first') || '',
                lastName: localStorage.getItem('user-last') || '',
                email: localStorage.getItem('user-email') || '',
                existMedia: ''
            };

            this.setUserAuth(server ,newUserAuth);
        } else {
            this.userAuth = ''
        }

        return this.userAuth;
    }

    public setUserAuth(serverKey: string, userAuth: UserResponse|UserRegisterResponse) {
        // this.api.setCommonHeader(serverKey, `${this.authHeaderPrefix}${userAuth.id}`);
        localStorage.setItem(serverKey+'-token', userAuth.id);
        if (userAuth.email) {
            localStorage.setItem('user-email', userAuth.email);
        }
        if (userAuth.firstName) {
            localStorage.setItem('user-first', userAuth.firstName);
        }
        if (userAuth.lastName) {
            localStorage.setItem('user-last', userAuth.lastName);
        }
        this.userAuth = userAuth;
    }

    public getUserToken(serverKey: string):string|boolean {
        return localStorage.getItem(serverKey+'-token') || false;
    }
}
